import axios, { type AxiosResponse } from 'axios'
import { CountryISO } from 'commons/constants/countries'
import type { CreateAISRequestResponse } from 'commons/services/moneyPotService'
import type { LydiaPageInfo, UserData } from 'commons/types/user'

export type CreateLydiaPageAISRequestParams = {
	pageTag: string
	amount: number
	iban: string
	recipientName: string
}

export const lydiaPageService = {
	getLydiaPageInfo: async (pageTag: string): Promise<LydiaPageInfo> => {
		return axios
			.get(`/l/collectio/user/phoneformdata?t=${pageTag}`)
			.then((res: AxiosResponse<UserData>) => {
				return {
					name: res.data.firstname,
					profilePicture: res.data.profile_picture,
					collectIban: res.data.collect_iban ?? '',
					collectBic: res.data.collect_bic ?? '',
					collectorName: res.data.collector_name
				}
			})
	},
	createAISRequest: async ({
		pageTag,
		amount,
		iban,
		recipientName
	}: CreateLydiaPageAISRequestParams): Promise<CreateAISRequestResponse> => {
		return axios
			.post(
				`${process.env.REACT_APP_GATEWAY_BASE_URL}aispis/public/lydia_page/${pageTag}/create-one-time-payment-request`,
				{
					amount,
					currency: 'EUR',
					destinations: [{ accountNumber: iban, type: 'iban' }],
					executionDate: new Date().toISOString().split('T')[0],
					market: CountryISO.FR,
					paymentScheme: 'SEPA_INSTANT_CREDIT_TRANSFER',
					recipientName,
					sourceMessage: 'Rechargement via IBAN'
				}
			)
			.then((res: AxiosResponse<CreateAISRequestResponse>) => res.data)
	}
}
